/* wwp-upsell.js v2 — site-wide "Pairs Well With" carousel
   Research: 4-8 items, peek next card, no auto-rotate on mobile,
   relevant label, individual add buttons
*/
(function(){
  if(window.wwpUpsell)return;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var CORAL='#E0948F',CHARCOAL='#2B2926',TAN='#CA9365',CREAM='#FFFDFB';
  var esc=function(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');};
  var pounds=function(v){
    if(typeof v==='number')return v/100;
    var s=String(v||0);
    return s.indexOf('.')!==-1?parseFloat(s):parseFloat(s)/100;
  };
  function imgSrc(p){
    var raw='',fi=p.featured_image;
    if(typeof fi==='string')raw=fi; else if(fi&&typeof fi==='object')raw=fi.src||fi.url||'';
    if(!raw&&p.images&&p.images.length){var f=p.images[0];raw=typeof f==='string'?f:((f&&(f.src||f.url))||'');}
    if(!raw)return '';
    if(raw.indexOf('//')==0)raw='https:'+raw;
    return raw+(raw.indexOf('?')>-1?'&':'?')+'width=320';
  }
  function isAvail(p){
    if(typeof p.available==='boolean')return p.available;
    return(p.variants||[]).some(function(v){return v.available;});
  }
  function priceText(p){
    var vs=(p.variants||[]).map(function(v){return pounds(v.price);}).filter(function(n){return!isNaN(n);});
    var min,varies=false;
    if(vs.length){min=Math.min.apply(null,vs);varies=Math.max.apply(null,vs)!==min;}
    else{min=pounds(p.price);varies=!!p.price_varies;}
    return(varies?'From ':'')+'£'+min.toFixed(2);
  }
  function getFirstVariantId(p){
    return p.variants&&p.variants[0]?p.variants[0].id:null;
  }
  function card(p){
    var src=imgSrc(p);
    var vid=getFirstVariantId(p);
    return '<div class="wwp-up__card">'+
      '<a href="'+root+'products/'+esc(p.handle)+'" class="wwp-up__img-link">'+
        (src?'<img src="'+esc(src)+'" alt="'+esc(p.title)+'" width="320" height="320" loading="lazy" class="wwp-up__img">':'<span class="wwp-up__ph"></span>')+
      '</a>'+
      '<div class="wwp-up__info">'+
        '<span class="wwp-up__title">'+esc(p.title)+'</span>'+
        '<span class="wwp-up__price">'+priceText(p)+'</span>'+
        (vid?'<button type="button" class="wwp-up__add" data-vid="'+vid+'" data-handle="'+esc(p.handle)+'">+ Add</button>':'')+
      '</div>'+
    '</div>';
  }
  function getJSON(url){return fetch(url).then(function(r){return r.ok?r.json():{};}).catch(function(){return{};});}
  function gather(seedId,exclude){
    var ex={};(exclude||[]).forEach(function(i){ex[String(i)]=1;});
    return Promise.all([
      seedId?getJSON(root+'recommendations/products.json?product_id='+seedId+'&limit=12&intent=related'):Promise.resolve({}),
      getJSON(root+'collections/popular-products/products.json?limit=15')
    ]).then(function(res){
      var out=[],seen={};
      (res[0].products||[]).concat(res[1].products||[]).forEach(function(p){
        var id=String(p.id);
        if(seen[id]||ex[id]||!isAvail(p)||(p.tags&&p.tags.join&&p.tags.join(',').indexOf('Bundle')>-1))return;
        seen[id]=1; out.push(p);
      });
      return out.slice(0,10);
    });
  }

  var addBtns={}; /* track added state across instances */

  function wireAddBtns(container){
    container.querySelectorAll('.wwp-up__add:not([data-wired])').forEach(function(btn){
      btn.setAttribute('data-wired','1');
      var vid=btn.getAttribute('data-vid');
      if(addBtns[vid]){btn.textContent='✓ Added';btn.classList.add('is-added');btn.disabled=true;}
      btn.addEventListener('click',function(){
        if(btn.classList.contains('is-adding')||btn.classList.contains('is-added'))return;
        btn.classList.add('is-adding');btn.textContent='Adding...';
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:parseInt(vid,10),quantity:1})
        }).then(function(r){return r.json();}).then(function(){
          btn.classList.remove('is-adding');btn.classList.add('is-added');btn.textContent='✓ Added';btn.disabled=true;
          addBtns[vid]=true;
          /* Sync all instances */
          document.querySelectorAll('.wwp-up__add[data-vid="'+vid+'"]').forEach(function(b){
            b.textContent='✓ Added';b.classList.add('is-added');b.disabled=true;
          });
          /* Update cart badge and delivery bar in modal */
          fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
            document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count-bubble span,.cart-count-bubble').forEach(function(el){el.textContent=c.item_count;});
            var progressFill=document.querySelector('.am-progress-fill');
            var progressMsg=document.querySelector('.am-progress-msg');
            if(progressFill&&progressMsg){
              var total=c.total_price/100,remaining=40-total;
              if(remaining<=0){
                var wrap=document.querySelector('#am-progress-wrap');
                if(wrap)wrap.innerHTML='<div class="am-progress-wrap"><p class="am-progress-done">🎉 You have FREE UK delivery on this order!</p></div>';
              } else {
                var pct=Math.min((total/40)*100,100);
                progressFill.style.width=pct+'%';
                progressMsg.innerHTML='Spend <em>£'+remaining.toFixed(2)+' more</em> for FREE UK delivery';
              }
            }
          });
        }).catch(function(){btn.classList.remove('is-adding');btn.textContent='+ Add';});
      });
    });
  }

  function initSlide(track,scope){
    /* No auto-rotate on mobile (NNg recommendation) */
    var isMobile=window.matchMedia&&matchMedia('(max-width:749px)').matches;
    if(isMobile)return;
    var paused=false,resume;
    var pause=function(){paused=true;clearTimeout(resume);resume=setTimeout(function(){paused=false;},7000);};
    var go=function(dir){
      var max=track.scrollWidth-track.clientWidth,c=track.querySelector('.wwp-up__card');
      var step=c?c.offsetWidth+12:track.clientWidth;
      if(dir>0&&track.scrollLeft>=max-4)track.scrollTo({left:0,behavior:'smooth'});
      else if(dir<0&&track.scrollLeft<=4)track.scrollTo({left:max,behavior:'smooth'});
      else track.scrollBy({left:dir*step,behavior:'smooth'});
    };
    var prevBtn=scope.querySelector('.wwp-up__nav--prev');
    var nextBtn=scope.querySelector('.wwp-up__nav--next');
    if(prevBtn)prevBtn.addEventListener('click',function(){pause();go(-1);});
    if(nextBtn)nextBtn.addEventListener('click',function(){pause();go(1);});
    ['pointerdown','touchstart','wheel','mouseenter','focusin'].forEach(function(e){track.addEventListener(e,pause,{passive:true});});
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches)return;
    var timer=setInterval(function(){
      if(!document.body.contains(track)){clearInterval(timer);return;}
      if(paused||getComputedStyle(track).visibility==='hidden')return;
      go(1);
    },3200);
  }

  function render(container,opts){
    opts=opts||{};
    return gather(opts.seedId,opts.exclude).then(function(list){
      if(list.length<2){container.innerHTML='';return;}
      var label=opts.label||'Pairs Well With';
      container.innerHTML=
        '<div class="wwp-up">'+
        '<p class="wwp-up__heading">'+label+'</p>'+
        '<div class="wwp-up__wrap">'+
        '<button type="button" class="wwp-up__nav wwp-up__nav--prev" aria-label="Previous">&#8249;</button>'+
        '<div class="wwp-up__track">'+list.map(card).join('')+'</div>'+
        '<button type="button" class="wwp-up__nav wwp-up__nav--next" aria-label="Next">&#8250;</button>'+
        '</div></div>';
      var track=container.querySelector('.wwp-up__track');
      if(track){initSlide(track,container);wireAddBtns(container);}
    });
  }

  /* Cart drawer upsell */
  function mountCart(){
    var d=document.getElementById('CartDrawer');
    if(!d)return;
    var items=d.querySelector('cart-drawer-items');
    if(!items||items.classList.contains('is-empty')||d.querySelector('.wwp-cart-upsell'))return;
    var box=document.createElement('div');
    box.className='wwp-cart-upsell';
    items.insertAdjacentElement('afterend',box);
    fetch(root+'cart.js').then(function(r){return r.json();}).then(function(cart){
      var ids=(cart.items||[]).map(function(i){return i.product_id;});
      if(ids.length)render(box,{seedId:ids[0],exclude:ids,label:'What Pet Parents Also Wuv'});
    }).catch(function(){});
  }

  function init(){
    var d=document.getElementById('CartDrawer');
    if(!d)return;
    mountCart();
    new MutationObserver(function(){mountCart();wireAddBtns(d);}).observe(d,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();

  window.wwpUpsell={render:render};
})();
